import React from 'react';
import './Body.css';
import { Navbar, NavItem , Nav } from 'react-bootstrap';

class Header extends React.Component
{
    render()
    {
        return (
            <Navbar fluid style={{background:'transparent', border:'0', marginBottom:'-52px'}}>
                <Navbar.Header>
                    <Navbar.Brand>
                        <a href="http://www.optimum-tracker.com" rel="noopener noreferrer" target="_blank">
                            <img src="/images/logo/logo-optimum-tracker-white2.png"
                                width="170px"
                                height="40px"
                                left="60px"
                                top="19px"
                                className="logo-optimum-tracker"
                                alt="Optimum Tracker" />
                        </a>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav pullRight>
                        <NavItem eventKey={1}>
                            <div id="power">
                                <p className="title-optimum-tracker">
                                    <img src="/images/logo/power-white.png"
                                        width="20"
                                        height="20"
                                        className="logo-optimum-tracker-power"
                                        alt="Optimum Tracker" />
                                    { Math.ceil(this.props.total) } MWp</p>
                            </div>
                        </NavItem>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

Header.defaultProps = {
	total: 0
};

export default Header;
